import {BehaviorSubject} from "rxjs";

export abstract class AbstractEvaluationComponent {
    public markType: BehaviorSubject<string> = new BehaviorSubject<string>('');
}
